import ApiService from '@/utils/ApiService'
import Swal from 'sweetalert2'
import Vue from 'vue'

export async function archive (id, successCallback = false, failureCallback = () => {}) {
  let decision = true
  if (successCallback) {
    decision = await Swal({
      title: Vue.prototype.$lang.t('notifications.archiveTitle'),
      type: 'question',
      showConfirmButton: true,
      confirmButtonText: Vue.prototype.$lang.t('buttons.yes'),
      showCancelButton: true,
      cancelButtonText: Vue.prototype.$lang.t('buttons.cancel')
    })
  }
  if (decision) {
    const response = await new ApiService(id).putSilent({ state: 0 })
    if (response.status === 200) {
      successCallback()
    } else {
      failureCallback()
    }
  }
}

export async function unArchive (id, successCallback = false, failureCallback = () => {}) {
  let decision = true
  if (successCallback) {
    decision = await Swal({
      title: Vue.prototype.$lang.t('notifications.unArchiveTitle'),
      type: 'question',
      showConfirmButton: true,
      confirmButtonText: Vue.prototype.$lang.t('buttons.yes'),
      showCancelButton: true,
      cancelButtonText: Vue.prototype.$lang.t('buttons.cancel')
    })
  }
  if (decision) {
    const response = await new ApiService(id).putSilent({ state: 1 })
    if (response.status === 200) {
      successCallback()
    } else {
      failureCallback()
    }
  }
}
